<template>
  <!-- <div v-if="value"> -->
    <b-input-group>
      <b-form-rating v-model="computedValue" variant="warning"></b-form-rating>
      <b-input-group-append>
        <b-input-group-text class="justify-content-center" style="min-width: 3em;">
          {{ value / 2000 }}
        </b-input-group-text>
      </b-input-group-append>
    </b-input-group>
  <!-- </div> -->
</template>

<script>
export default {
  props: {
    value: {
      Type: Number
    },
  },
  computed: {
    computedValue: {
      get: function() {
        return this.value / 2000
      },
      set: function(modifiedValue) {
        this.$emit('input', modifiedValue * 2000)
      }
    }
  }
}
</script>